import React from "react";

import Text from "./text";

class TextContainer extends React.Component {
  constructor(props) {
    super(props);

    // arbitrary business logic
    this.fakeData = "fake data";
  }

  render() {
    if (this.props.data.header) {
      return (
        <Text header={this.props.data.header} text={this.props.data.text} />
      );
    }
    return <Text text={this.props.data.text} />;
  }
}
export default TextContainer;
